import { queryClient } from "~/app/queryClient";
import { clearOccToken } from "~/app/api/occ/occToken";
import { clearSessionRuntimeState, resetSessionRuntimeFromPersistedContext } from "~/domains/user/sessionRuntime";
import { clearPunchoutSession } from "~/domains/cart/punchoutSession";
import { subscribeToAuthTabChanges } from "~/features/auth/login/api/authTabChannel";

let installed = false;

/**
 * Cross-tab authentication receiver (0213 grill Q4/Q5/Q8): another tab of
 * this origin changed the authentication state (login, logout, expiry). The
 * shared token storage already holds the new truth, so this tab drops every
 * identity-bound projection — the synchronous session runtime and the whole
 * query cache — and `resetQueries()` refetches ACTIVE queries, so the session
 * query re-resolves: SessionProvider republishes the runtime snapshot and remounts
 * the subtree on the new identity. On a logout/expiry receipt the shared
 * tokens are already gone, so the re-resolution lands on anonymous state.
 *
 * The event is a notification only (grill Q3): it is never consulted as an
 * authorization fact, and the acting tab owns the server-side session end
 * (grill Q5).
 */
export function installCrossTabAuthReceiver(): void {
  if (installed) {
    return;
  }
  installed = true;
  subscribeToAuthTabChanges((reason) => {
    clearPunchoutSession();
    if (reason === "asm") {
      resetSessionRuntimeFromPersistedContext();
    } else {
      clearSessionRuntimeState();
    }
    clearOccToken();
    void queryClient.resetQueries();
  });
}
